import cx from 'classnames'
import React from 'react'

import { Arrow } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './accordion.module.css'
import { buildTagDataAttr } from '@cinch/oxd-utils/analytics/src'

interface CustomStyles {
  container?: string
  containerExpanded?: string
  wrapper?: string
  button?: string
  label?: string
  icon?: string
}

interface AccordionProps {
  isExpanded?: boolean
  customStyles?: CustomStyles
  label: string
  iconSize?: string | number
  isNested?: boolean
}

const defaultIconSize = tokens.customProperties.spacing.xl

const Accordion: React.FC<AccordionProps> = ({
  isExpanded = false,
  customStyles = {},
  label,
  iconSize = defaultIconSize,
  isNested = false,
  children,
}) => {
  const [isStateExpanded, setStateExpanded] = React.useState(isExpanded)

  const tag = {
    event: 'click',
    eventCategory: 'accordion',
    eventLabel: label,
    eventAction: isStateExpanded ? 'collapse' : 'expand',
  }

  const analyticsDataAttributes = buildTagDataAttr(tag)

  return (
    <>
      <div className={cx(styles.container, customStyles.container, isStateExpanded && customStyles.containerExpanded)}>
        <div className={cx(styles.wrapper, customStyles.wrapper)}>
          <button
            type="button"
            aria-expanded={isStateExpanded}
            onClick={() => setStateExpanded(!isStateExpanded)}
            className={cx(styles.button, customStyles.button)}
            {...analyticsDataAttributes}
          >
            <span className={cx(styles.label, customStyles.label)}>{label}</span>
            <SVG
              size={iconSize}
              children={Arrow}
              className={cx(styles.icon, customStyles.icon, { [styles.iconExpanded]: isStateExpanded })}
              dataTestId="arrow-button"
            />
          </button>
        </div>
        {isStateExpanded && isNested && children}
      </div>
      {isStateExpanded && !isNested && children}
    </>
  )
}

export default Accordion
